import { Map, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_WISHROUTE_FOCUS_DATA:
      return state
        .setIn(['data', 'focus'], action.payload)
    case actions.SET_WISHROUTE_OPTION_DATA:
      return state
        .setIn(['data', 'options'], action.payload)
    case actions.RESET_WISHROUTE_OPTION_DATA:
      return state
        .deleteIn(['data', 'options'])
    case actions.DELETE_WISHROUTE_DATA:
      return state
        .delete('data')
        .delete('processing')
    case actions.SET_WISHROUTE_PHONE:
      return state
        .setIn(['data', 'phone'], action.payload)
    case actions.SET_WISHROUTE_SIGNUP_PROCESSING:
      return state
        .set('processing', action.payload)
    case actions.SET_WISHROUTE_SIGNUP_DATA:
      return state
        .setIn(['data', 'signup'], fromJS(action.payload.data))
        .set('processing', action.payload.processing)
    default:
      return state
  }
}
